// extracted by mini-css-extract-plugin
export default {"columnFixed":"TableLayout_columnFixed__SUjWr","columnScrollable":"TableLayout_columnScrollable__3NG7f","placeHolderShimmer":"TableLayout_placeHolderShimmer__X42TV"};